import {marked} from 'marked'
import DOMPurify from 'dompurify'

function baseUrl(base, baseLink) {
  const reIsAbsolute = /^[\w+]+:\/\//
  const dummyUrl = 'http://__dummy__'

  let isBaseAbsolute
  let dummyBaseUrl
  let dummyUrlLength
  if (base) {
    base = base.trim().replace(/\/+$/, '/') // if multiple '/' at the end, just keep one
    isBaseAbsolute = reIsAbsolute.test(base)
    dummyBaseUrl = new URL(base, dummyUrl)
    dummyUrlLength = dummyUrl.length + (base.startsWith('/') ? 0 : 1)
  }

  baseLink = baseLink.trim().replace(/\/+$/, '/')
  const isBaseAbsoluteLink = reIsAbsolute.test(baseLink)
  const dummyBaseUrlLink = new URL(baseLink, dummyUrl)
  const dummyUrlLengthLink = dummyUrl.length + (baseLink.startsWith('/') ? 0 : 1)

  return {
    walkTokens(token) {
      if (!['link', 'image'].includes(token.type)) {
        return
      }
      if (token.mncDone) {
        return
      }
      if (reIsAbsolute.test(token.href)) {
        // the URL is absolute, do not touch it
        return
      }
      if (token.href.startsWith('#')) {
        // the URL is a local reference
        return
      }
      if (token.href.startsWith('data:')) {
        // the URL is a base64 data URI
        return
      }
      if ('image' == token.type) {
        if (!base) {
          return
        }
        if (isBaseAbsolute) {
          try {
            token.href = new URL(token.href, base).href
            token.mncDone = true
          } catch {
            // ignore
          }
        } else {
          // base is not absolute
          if (token.href.startsWith('/')) {
            // the URL is from root
            return
          }
          try {
            const temp = new URL(token.href, dummyBaseUrl).href
            token.href = temp.slice(dummyUrlLength)
            token.mncDone = true
          } catch {
            // ignore
          }
        }
      } else {
        if (isBaseAbsoluteLink) {
          try {
            token.href = new URL(token.href, baseLink).href
            token.mncDone = true
          } catch {
            // ignore
          }
        } else {
          // base is not absolute
          if (token.href.startsWith('/')) {
            // the URL is from root
            return
          }
          try {
            const temp = new URL(token.href, dummyBaseUrlLink).href
            token.href = temp.slice(dummyUrlLengthLink)
            token.mncDone = true
          } catch {
            // ignore
          }
        }

      }
    }
  }
}

class Marked extends React.Component {

  data = null

  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
  }

  componentDidMount() {
    this.data = MC.extend({}, this.props.data.param)
    this.update(this.props)
  }

  componentDidUpdate() {
    if (JSON.stringify(this.data) != JSON.stringify(this.props.data.param)) {
      if (this.data.value != this.props.data.param.value) {
        this.update(this.props)
      }
      this.data = MC.extend({}, this.props.data.param)
    }
  }

  update(props) {
    const markdownText = MC.getFieldParamValue(props.data.param, 'value')
    const baseUrlParam = MC.getFieldParamValue(props.data.param, '@baseUrl')
    marked.use(baseUrl(baseUrlParam, MC.isNull(baseUrlParam) ? props.data.flow.baseUrlForLink : baseUrlParam))
    let html = ''
    if (!MC.isNullOrEmpty(markdownText)) {
      html = DOMPurify.sanitize(marked(markdownText))
    }
    if (this.containerRef.current) {
      this.containerRef.current.innerHTML = html
    }
  }

  render() {
    return <div ref={this.containerRef} />
  }

}

MC.registerReactRomponent('marked', Marked)